import type { ErrorEvent, EventHint } from "@sentry/browser";
import { AppSyncError } from "./aws/appsync/AppSyncError.js";

export function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent {
	const exception = hint.originalException;

	if (exception instanceof AppSyncError) {
		const groupErrorMessages = [/Signature not yet current:/u, /Signature expired:/u];
		if (groupErrorMessages.some((message) => message.test(exception.message))) {
			event.fingerprint = [exception.message];
		} else {
			event.fingerprint = ["{{ default }}", String(exception.name), String(exception.message)];
		}
	}

	return event;
}
